import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { initiatives } from '../data/mock';

export default function Initiatives() {
  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Reduction Initiatives</h1>
          <p className="text-slate-400 text-sm mt-1">Track decarbonization projects and their expected impact.</p>
        </div>
        <button className="px-4 py-2 text-sm font-medium text-slate-900 bg-emerald-500 rounded-lg hover:bg-emerald-400 transition-colors shadow-[0_0_15px_rgba(16,185,129,0.3)] flex items-center gap-2">
          <SafeIcon name="PlusCircle" className="w-4 h-4" /> New Project
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
        {['Planning', 'In Progress', 'Testing', 'Completed'].map(stage => (
          <div key={stage} className="flex flex-col gap-4">
            <div className="flex items-center justify-between px-2">
              <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider">{stage}</h3>
              <span className="bg-slate-800 text-slate-400 text-xs py-0.5 px-2 rounded-full">
                {initiatives.filter(i => (stage === 'Completed' ? i.status === 'Completed' : stage === 'In Progress' ? i.status === 'In Progress' : stage === 'Planning' ? i.status === 'Planning' : false)).length}
              </span>
            </div>
            
            <div className="space-y-4">
              {initiatives.filter(i => (stage === 'Completed' ? i.status === 'Completed' : stage === 'In Progress' ? i.status === 'In Progress' : stage === 'Planning' ? i.status === 'Planning' : false)).map(init => (
                <div key={init.id} className="glass-panel p-4 rounded-xl cursor-pointer hover:-translate-y-1 transition-transform duration-200">
                  <div className="flex justify-between items-start mb-2">
                    <span className="text-xs font-mono text-cyan-400 bg-cyan-500/10 px-2 py-0.5 rounded border border-cyan-500/20">{init.category}</span>
                    <button className="text-slate-500 hover:text-slate-300"><SafeIcon name="MoreHorizontal" className="w-4 h-4" /></button>
                  </div>
                  <h4 className="text-slate-100 font-medium text-sm mb-3 leading-snug">{init.title}</h4>
                  
                  <div className="space-y-2">
                    <div className="flex justify-between text-xs text-slate-400">
                      <span>Progress</span>
                      <span>{init.progress}%</span>
                    </div>
                    <div className="w-full bg-slate-800 h-1.5 rounded-full overflow-hidden">
                      <div 
                        className={`h-full rounded-full ${init.progress === 100 ? 'bg-emerald-500' : 'bg-cyan-500'}`} 
                        style={{ width: `${init.progress}%` }}
                      ></div>
                    </div>
                  </div>
                  
                  <div className="mt-4 pt-3 border-t border-slate-800 flex justify-between items-center text-xs">
                    <span className="text-slate-500">Est. Impact:</span>
                    <span className="font-mono text-emerald-400">-{init.expectedReduction} tCO2e</span>
                  </div>
                </div>
              ))}
              
              {/* Empty state for droppable columns */}
              {initiatives.filter(i => (stage === 'Completed' ? i.status === 'Completed' : stage === 'In Progress' ? i.status === 'In Progress' : stage === 'Planning' ? i.status === 'Planning' : false)).length === 0 && (
                <div className="border-2 border-dashed border-slate-800 rounded-xl h-24 flex items-center justify-center text-slate-500 text-sm">
                  Drop projects here
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}